import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { getPatientProfile } from "@/redux/actions/auth";

import { updatePatientProfile } from "../queryFunctions/updatePatientProfile";

export function useUpdatePatientProfile() {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: updatePatientProfile,
    onSuccess: () => {
      dispatch(getPatientProfile(true));
      // use when more patientProfile react-query refactors happen
      // queryClient.invalidateQueries({ queryKey: usePatientProfileKey.base });
    },
  });
}
